export default __webpack_public_path__ + "img/legals-banner.asset.292b9ec6.png";